// extracted by mini-css-extract-plugin
export default {"text":"QMEla","path":"tyZt0"};